import Logo from '@/assets/images/logo.svg?react';
import BrandLogo from '@/components/BrandLogo';
import { isIdenBrand } from '@/consts/brand';
import { Daisy as Spinner } from '@/ds-components/Spinner';

import styles from './index.module.scss';

function AppLoading() {
  return (
    <div className={styles.container}>
      {isIdenBrand ? <BrandLogo /> : <Logo />}
      <Spinner />
    </div>
  );
}

export default AppLoading;
